import classNames from 'classnames'

import CardComponent from '@/components/CardComponent/index'

import styles from './index.module.scss'

const CardList = ({ className, emptyState, items = [], noCard = false, renderItem }) => {
  const safeItems = Array.isArray(items) ? items : []

  if (safeItems.length === 0) {
    if (!emptyState) {
      return null
    }
    return <div className={className}>{emptyState}</div>
  }

  if (!renderItem) {
    return null
  }

  const itemsContent = (
    <>
      {safeItems.map((item, index) => (
        <div key={item.id ?? `card-item-${index}`}>
          {renderItem(item)}
          {index < safeItems.length - 1 && <div className={styles.divider} />}
        </div>
      ))}
    </>
  )

  if (noCard) {
    return (
      <div className={classNames(styles.cardList, className)}>
        <div className='ew-d-flex ew-flex-column'>
          <div className={styles.divider} />
          {itemsContent}
        </div>
      </div>
    )
  }

  return (
    <div className={classNames(styles.cardList, className)}>
      <CardComponent>{itemsContent}</CardComponent>
    </div>
  )
}

export default CardList
